import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-to-reorder the widget list on the Customize Dashboard page. Dragging by
// the grip handle reorders the rows and persists the new order to the server
// (each widget's position = its index). forceFallback avoids the flaky native
// HTML5 drag path (same fix as the packing editor).
export default class extends Controller {
  static values = { url: String, csrf: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-reorder-handle]",
      draggable: "[data-widget-id]",
      forceFallback: true,
      animation: 150,
      ghostClass: "reorder-ghost",
      onEnd: () => this.save()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  save() {
    const ids = Array.from(this.element.querySelectorAll("[data-widget-id]"))
      .map(el => el.dataset.widgetId)

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfValue,
        "Accept": "application/json"
      },
      body: JSON.stringify({ ids })
    })
  }
}
